import AllAgentApplicationsScreen from '@/components/Home/AllAgentApplicationsScreen.js';
import React, {useRef} from 'react';

const HistoryPage = () => {
  const tasksRef = useRef();

  return (
    <AllAgentApplicationsScreen ref={tasksRef} />
  );
};

export default HistoryPage;
